<nav *ngIf="fleet" class="breadcrumb">
	<a class="breadcrumb-item" [routerLink]="['../../../']">My {{brand.fleetPlural}}</a>
	<a class="breadcrumb-item" [routerLink]="['../']">{{fleet?.fleet_name}}</a>
	<span class="breadcrumb-item active">Usage Report</span>
</nav>
<div *ngIf="fleet && assets" class="item-panel corner">
	<div class="heading">Usage Report</div>
	<div class="content">
		<p>This will generate a report in XLSX format for the selected assets:</p>
		<div class="row mt-4">
			<ng-container *ngFor="let asset of assets">
				<div class="col-sm-4 col-lg-3">
					<label>
						<input type="checkbox" [(ngModel)]="asset.selected"> {{asset.asset_name}}
					</label>
				</div>
			</ng-container>
		</div>
		<div class="row">
			<div class="col-md-12">
				Select <a href="javascript:void(0);" (click)="SelectAll()">all</a> / <a href="javascript:void(0);" (click)="SelectNone()">none</a>
			</div>
		</div>
		<div class="form-group row my-4">
			<label class="col-md-2 align-content-sm-center">Start Date:</label>
			<div class="col-lg-3 col-md-4">
				<app-day-picker [(ngModel)]="startDate"></app-day-picker>
			</div>
			<label class="col-md-2 offset-lg-1 align-content-sm-center">End Date:</label>
			<div class="col-lg-3 col-md-4">
				<app-day-picker [(ngModel)]="endDate"></app-day-picker>
			</div>
		</div>
		<div class="form-group row my-4">
			<div class="col-md-4 form-group">
				<label class="form-check-label">
					<input type="checkbox" [(ngModel)]="includeOperations">
					Include operation list
				</label>
			</div>
			<div class="col-md-4 form-group">
				<label class="form-check-label">
					<input type="checkbox" [(ngModel)]="includeExceedances">
					Include exceedance list
				</label>
			</div>
			<div class="col-md-4 form-group">
				<label class="form-check-label">
					<input type="checkbox" [(ngModel)]="includeUserAccess">
					Include user access list
				</label>
			</div>
		</div>
		<div class="form-group row">
			<div class="col-md-12">
				<app-action-button [action]="GenerateReport" [context]="this" processing="Generating...">
					Generate Report</app-action-button>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!fleet" class="text-center pt-3 pb-5">
	<div class="logo-spin light"></div>
	Loading fleet...
</div>
<div *ngIf="fleet && assets === null" class="text-center pt-3 pb-5">
	No assets found in this fleet
</div>